/**
 * Record API service (только запросы)
 */
window.recordPageService = {
    async post(url, params = {}) {
        const response = await fetch(url, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': window.appConfig.csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params || {}),
        });

        if (!response.ok) {
            return { status: response.status, data: null, detail: null };
        }

        return await response.json();
    },

    getProfessions() {
        return this.post(window.appConfig.routes.recordGetProfessions, {});
    },

    getDoctors(professionId) {
        return this.post(window.appConfig.routes.recordGetDoctors, {
            profession_id: Number(professionId || 0),
            is_visibleOnSite: "Y",
        });
    },

    getServices(professionId, userId) {
        return this.post(window.appConfig.routes.recordGetServices, {
            profession_id: Number(professionId || 0),
            user_id: Number(userId || 0),
        });
    },

    getSchedule(userId, startAt, days, storeId) {
        return this.post(window.appConfig.routes.recordGetSchedule, {
            user_id: Number(userId || 0),
            store_id: Number(storeId || 0),
            start_at: String(startAt || ''),
            days: Number(days || 14),
        });
    },

    getDoctorStores(userId) {
        return this.post(window.appConfig.routes.getDoctorStores, {
            user_id: Number(userId || 0)
        });
    },



    add(payload) {
        return this.post(window.appConfig.routes.recordAdd, payload);
    },
};